import { actions } from './types';

export const requestActions = (entityId, promise) => ({
  type: actions.request,
  entityId,
  promise,
});

export const requestActionsSuccess = (response) => ({
  type: actions.success,
  response,
});

export const requestActionsFailure = (error) => ({
  type: actions.failure,
  error,
});
